/* Brand My Cap – branding + on-demand pricing rules, setup fees, minimums, shipping (shared core) */
(function () {
  'use strict';

  var FEE_HANDLE = 'branding-setup-fee';
  /* Charge products: 'Branding' (per cap), 'Branding setup' (once per logo + position), and the older combined product
     (now only used for custom-cap sample / design fees, and to clean up carts that still hold its old lines) */
  var FEE_HANDLES = ['branding-setup-fee', 'bmc-branding', 'bmc-branding-setup'];
  function isFee(it) { return FEE_HANDLES.indexOf(it.handle) >= 0; }
  /* Branding per cap (price -> variant of 'Branding') */
  var BRAND_VARIANTS = {
    '33.60': 50960973496377, '21.71': 50960973529145, '14.66': 50960973561913, '22.96': 50960973594681,
    '14.83': 50960973627449, '10.15': 50960973660217, '53.12': 50960973692985, '42.64': 50960973725753,
    '21.49': 50960973758521, '7.35': 50960973791289, '21.64': 50960973824057, '26.01': 50960973856825,
    '21.10': 50960973889593,
    /* Flexfit branding per cap (1-99 / 100-199 / 200+) */
    '54.60': 51046633078841, '49.00': 51046633111609, '44.80': 51046633144377,
    '91.00': 51046633177145, '82.60': 51046633209913, '77.00': 51046633242681
  };
  /* Branding setup (amount -> variant of 'Branding setup') */
  var SETUP_VARIANTS = {
    '70.00': 50960973955129, '140.00': 50960973987897, '168.00': 50960974020665, '175.00': 50960974053433,
    '210.00': 50960974086201, '280.00': 50960974118969, '301.00': 50960974151737, '350.00': 50960974184505
  };
  /* Custom-cap (on demand) sample and design fees stay on the older product */
  var OD_VARIANTS = { '350.00': 50889545646137, '650.00': 50895297740857 };
  var OD_SAMPLE = 350;
  var OD_DESIGN = 650;
  var OD_DESIGN_TEXT = 'Our designer creates your full print artwork on the manufacturing template from your logo and brief, with a digital proof and one round of changes before sampling.';
  var OD_TIERS = [3, 50, 150, 300, 600, 1000, 3000, 12000];
  var OD_TIER_LABELS = ['3 – 49', '50 – 149', '150 – 299', '300 – 599', '600 – 999', '1 000 – 2 999', '3 000 – 11 999', '12 000+'];

  /* fee: emb = embroidery setup tiers, heat = print setup, badge = DTF badge setup, leather = leather badge setup,
          quote = confirmed on quote, none = no setup fee (Flexfit branding)
     min: minimum caps across the whole order for that method (0 = none)
     pc: branding cost per cap ex VAT by quantity band [1-14, 15-49, 50+] (one value = any quantity),
         or by the bands in tq (e.g. [0, 100, 200] = 1-99 / 100-199 / 200+).
         No pc = branding cost confirmed on quote. Our price = pc x MARKUP.
     set: 'ff' = Flexfit caps only; no set = all other caps */
  var METHODS = [
    { k: 'flat-emb', n: 'Flat embroidery', fee: 'emb', min: 0, pc: { front: [24.00, 15.51, 10.47], small: [16.40, 10.59, 7.25] } },
    { k: '3d-emb', n: '3D (puff) embroidery', fee: 'emb', min: 0, pc: [37.94, 30.46, 15.35] },
    { k: 'dtf', n: 'DTF print', fee: 'heat', min: 0, pc: [5.25] },
    { k: 'pu', n: 'PU heat transfer', fee: 'heat', min: 0 },
    { k: 'dtf-patch', n: 'DTF print patch', fee: 'badge', min: 0, pc: [15.46] },
    { k: 'raised-dtf', n: 'Raised DTF patch', fee: 'badge', min: 0 },
    { k: 'flat-emb-patch', n: 'Flat embroidered patch', fee: 'emb', min: 0 },
    { k: '3d-emb-patch', n: '3D embroidered patch', fee: 'emb', min: 0 },
    { k: '3d-pu', n: '3D PU / UV print', fee: 'heat', min: 0, pc: [18.58] },
    { k: 'leather', n: 'Leather patch', fee: 'leather', min: 50, pc: [15.07] },
    { k: 'flock', n: 'Cut flock', fee: 'quote', min: 50, perCap: null },
    { k: 'matte', n: 'Matte patch', fee: 'quote', min: 50, perCap: null },
    { k: 'debossed', n: 'Debossed patch', fee: 'quote', min: 50, perCap: null },
    { k: 'reflective', n: 'Reflective print', fee: 'quote', min: 50, perCap: null },
    { k: 'rubber', n: 'Rubber patch', fee: 'quote', min: 50, perCap: null },
    { k: 'silicone', n: 'Silicone patch', fee: 'quote', min: 50, perCap: null },
    { k: 'sublimation', n: 'Sublimation (gaiters)', fee: 'quote', min: 50, perCap: null },
    { k: 'tpu', n: 'TPU', fee: 'quote', min: 300, perCap: null },
    { k: 'woven-patch', n: 'Woven patch', fee: 'quote', min: 300, perCap: null },
    { k: 'satin-label', n: 'Satin label', fee: 'quote', min: 1000, perCap: null },
    { k: 'woven-label', n: 'Woven label', fee: 'quote', min: 1000, perCap: null },
    { k: 'deboss-strap', n: 'Debossed strap', fee: 'quote', min: 0, perCap: null, note: 'minimum confirmed on quote' },
    { k: 'jibbitz', n: 'Jibbitz / clip-ons', fee: 'quote', min: 0, perCap: null, note: 'minimum confirmed on quote' },
    /* Flexfit caps: no setup fees, minimum 72 branded caps, price per cap drops at 100+ and 200+ */
    { k: 'ff-flat-emb', n: 'Flat embroidery', set: 'ff', fee: 'none', min: 72, pc: [39, 35, 32], tq: [0, 100, 200], lead: 15 },
    { k: 'ff-3d-emb', n: '3D embroidery', set: 'ff', fee: 'none', min: 72, pc: [39, 35, 32], tq: [0, 100, 200], lead: 15 },
    { k: 'ff-flat-badge', n: 'Flat embroidered badge', set: 'ff', fee: 'none', min: 72, pc: [39, 35, 32], tq: [0, 100, 200], lead: 15 },
    { k: 'ff-dtf', n: 'DTF print', set: 'ff', fee: 'none', min: 72, pc: [39, 35, 32], tq: [0, 100, 200], lead: 15 },
    { k: 'ff-rubber', n: 'Rubber badge', set: 'ff', fee: 'none', min: 72, pc: [65, 59, 55], tq: [0, 100, 200], lead: 45 },
    { k: 'ff-pu', n: 'PU patch', set: 'ff', fee: 'none', min: 72, pc: [65, 59, 55], tq: [0, 100, 200], lead: 45 },
    { k: 'ff-embossed', n: 'Embossed badge', set: 'ff', fee: 'none', min: 72, pc: [65, 59, 55], tq: [0, 100, 200], lead: 45 },
    { k: 'ff-silicone', n: '2D silicone transfer', set: 'ff', fee: 'none', min: 72, pc: [65, 59, 55], tq: [0, 100, 200], lead: 45 }
  ];
  var POSITIONS = ['Front', 'Left side', 'Right side', 'Back', 'Under peak', 'Top of peak', 'Back strap'];
  var COUNTRIES = ['South Africa', 'Botswana', 'Eswatini', 'Lesotho', 'Mozambique', 'Namibia', 'Zimbabwe'];

  function method(k) {
    for (var i = 0; i < METHODS.length; i++) if (METHODS[i].k === k) return METHODS[i];
    return null;
  }
  function money(n) {
    return 'R' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function odTier(qty) {
    var t = 0;
    for (var i = 0; i < OD_TIERS.length; i++) if (qty >= OD_TIERS[i]) t = i;
    return t;
  }

  /* Setup fees for ONE logo at ONE position, given the number of caps carrying it. H24 setup fees (ex VAT) + 40%:
       Embroidery: the cap's 1st embroidered logo R200 / R150 / R125 (1-14 / 15-49 / 50+ caps) -> R280 / R210 / R175,
         2nd embroidered logo R100 (under 50) / R50 -> R140 / R70, 3rd+ R50 -> R70 (no separate digitising fee on H24 quotes)
       Print (DTF, PU, 3D UV): 1st printed logo R120 -> R168, further printed logos R50 -> R70
       DTF badge R250 each -> R350; leather badge R215 -> R301
     rank = 1 for the first logo of that kind on the cap, 2 for the second, ... */
  var MARKUP = 1.4;
  function mk(h24) { return Math.round(h24 * MARKUP * 100) / 100; }
  function setupFees(m, qty, first, rank) {
    var out = [];
    if (!m) return out;
    rank = rank || (first ? 1 : 2);
    if (m.fee === 'emb') {
      if (rank === 1) out.push({ label: 'Embroidery setup', amt: mk(qty < 15 ? 200 : qty < 50 ? 150 : 125) });
      else out.push({ label: 'Embroidery setup (extra logo)', amt: mk(rank === 2 && qty < 50 ? 100 : 50) });
    } else if (m.fee === 'heat') {
      out.push({ label: rank === 1 ? 'Print setup' : 'Print setup (extra logo)', amt: mk(rank === 1 ? 120 : 50) });
    } else if (m.fee === 'badge') {
      out.push({ label: 'Badge setup', amt: mk(250) });
    } else if (m.fee === 'leather') {
      out.push({ label: 'Leather badge setup', amt: mk(215) });
    }
    return out;
  }
  /* Estimated branding price per cap (ours, ex VAT) for a method at a position and quantity; null = on quote */
  function brandPrice(m, pos, qty) {
    if (!m || !m.pc) return null;
    var arr = Array.isArray(m.pc) ? m.pc : (/^front$/i.test(pos || '') ? m.pc.front : m.pc.small);
    var t;
    if (m.tq) { t = 0; for (var i = 0; i < m.tq.length; i++) if (qty >= m.tq[i]) t = i; }
    else t = qty < 15 ? 0 : qty < 50 ? 1 : 2;
    return mk(arr[Math.min(t, arr.length - 1)]);
  }
  /* Methods that come with a pre-production sample cap */
  function sampled(m) { return m && m.fee !== 'quote' && m.fee !== 'none'; }
  /* rank of each branding among logos of the same setup kind on one cap, in position order */
  function ranks(list) {
    var seen = {};
    list.forEach(function (b) { if (!b.m) return; seen[b.m.fee] = (seen[b.m.fee] || 0) + 1; b.rank = seen[b.m.fee]; });
    return list;
  }

  function shipping(caps) {
    if (caps <= 0) return { amt: 0, label: '' };
    if (caps <= 25) return { amt: 150, label: '1–25 caps' };
    if (caps <= 50) return { amt: 250, label: '26–50 caps' };
    return { amt: null, label: 'More than 50 caps: we will quote delivery' };
  }

  /* Read branding positions stored on a cart line */
  function lineBrandings(item) {
    var p = item.properties || {};
    var out = [];
    for (var i = 1; i <= 3; i++) {
      var mk2 = p['_bmc_m' + i];
      if (!mk2) continue;
      var raw = (p['Logo ' + i + ' name'] || p['Logo name'] || ('Logo ' + i)).toString().trim();
      out.push({ i: i, m: method(mk2), pos: p['_bmc_p' + i] || '', logo: raw.toLowerCase(), logoName: raw, first: i === 1, later: !!p['Logo ' + i], file: p['Logo ' + i + ' file'] || '' });
    }
    return ranks(out);
  }
  /* One setup is charged per logo + position + method across the whole cart (shared by every cap carrying it) */
  function groupKey(b) { return b.m.k + '|' + b.pos.toLowerCase() + '|' + b.logo; }

  /* Analyse a cart (from /cart.js) */
  function analyse(cart) {
    var unbranded = [], caps = 0, groups = {}, order = [], methodQty = {}, feeLines = {}, capsTotal = 0, quoteMethods = {};
    var od = {}, lineGroups = {}, haveSamples = [], samples = {}, sampleOrder = [], requested = [], tiers = {};
    cart.items.forEach(function (it) {
      if (isFee(it)) {
        if (!it.parent_relationship) feeLines[it.variant_id] = (feeLines[it.variant_id] || 0) + it.quantity;
        return;
      }
      var p = it.properties || {};
      if (p._bmc_sample) {
        haveSamples.push(it);
        return;
      }
      caps += it.quantity;
      capsTotal += it.final_line_price;
      /* Quantity price tiers (e.g. Flexfit, socks): counted per colour across the cart */
      if (p._bmc_tt) {
        var tk = p._bmc_tt;
        if (!tiers[tk]) tiers[tk] = { qty: 0, lines: [], tq: p._bmc_tq || '', min: Number(p._bmc_tmin) || 0, title: it.product_title };
        tiers[tk].qty += it.quantity;
        tiers[tk].lines.push(it);
      }
      if (p._bmc_od) {
        var st = p._bmc_style || it.variant_title;
        if (!od[st]) od[st] = { qty: 0, lines: [], design: false };
        od[st].qty += it.quantity;
        if (/^Let/i.test(p.Design || '')) od[st].design = true;
        od[st].lines.push(it);
        return;
      }
      var seen = {};
      var lb = lineBrandings(it);
      lineGroups[it.key] = [];
      if (p._bmc_req) requested.push(it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : ''));
      else if (!lb.length && p.Branding !== 'No branding') unbranded.push(it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : ''));
      /* One pre-production sample cap per branded cap style/colour, charged at the cap price (H24: sample = cap + branding) */
      if (lb.some(function (b) { return sampled(b.m); }) && !samples[it.variant_id]) {
        samples[it.variant_id] = { id: it.variant_id, owner: it.key, cap: it.final_price / 100, amt: it.final_price / 100, title: it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '') };
        sampleOrder.push(it.variant_id);
      }
      lb.forEach(function (b) {
        if (!b.m) return;
        var key = groupKey(b);
        if (!groups[key]) {
          groups[key] = { key: key, m: b.m, pos: b.pos, logo: b.logo, logoName: b.logoName, first: false, idx: b.rank, qty: 0, owner: it.key, ownerTitle: it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '') };
          order.push(key);
        }
        if (b.first) groups[key].first = true;
        if (b.rank < groups[key].idx) groups[key].idx = b.rank;
        groups[key].qty += it.quantity;
        if (lineGroups[it.key].indexOf(key) < 0) lineGroups[it.key].push(key);
        if (!seen[b.m.k]) { methodQty[b.m.k] = (methodQty[b.m.k] || 0) + it.quantity; seen[b.m.k] = 1; }
        if (b.m.fee === 'quote') quoteMethods[b.m.n] = 1;
      });
    });
    /* Estimated branding per cap: priced on the number of caps carrying that logo in that position */
    var brandEst = 0, lineEst = {}, unpriced = {};
    function priceOf(b) { var g = groups[groupKey(b)]; return brandPrice(b.m, b.pos, g ? g.qty : 1); }
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (isFee(it) || p._bmc_sample || p._bmc_od) return;
      var per = 0;
      lineBrandings(it).forEach(function (b) {
        if (!b.m) return;
        var pc = priceOf(b);
        if (pc == null) { if (b.m.fee !== 'quote') unpriced[b.m.n] = 1; return; }
        per += pc;
      });
      lineEst[it.key] = per;
      brandEst += per * it.quantity;
      if (samples[it.variant_id] && samples[it.variant_id].owner === it.key) {
        samples[it.variant_id].brand = per;
        samples[it.variant_id].amt = samples[it.variant_id].cap + per;
        samples[it.variant_id].parts = lineBrandings(it).filter(function (b) { return b.m && priceOf(b) != null; })
          .map(function (b) { return { pos: b.pos, n: b.m.n, amt: priceOf(b) }; });
      }
    });
    var fees = [], need = {}, children = [];
    /* Branding per cap: nested under the cap line it belongs to (one line per position, quantity = caps on that line) */
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (isFee(it) || p._bmc_sample || p._bmc_od) return;
      lineBrandings(it).forEach(function (b) {
        if (!b.m) return;
        var pc = priceOf(b);
        if (pc == null) return;
        var id = BRAND_VARIANTS[pc.toFixed(2)];
        if (id) children.push({ parent: it.key, id: id, quantity: it.quantity, properties: { For: b.pos + ' – ' + b.m.n + ' – ' + b.logoName } });
      });
    });
    function count(amt) {
      var id = OD_VARIANTS[amt.toFixed(2)];
      need[id] = (need[id] || 0) + 1;
    }
    function addFee(label, amt) {
      fees.push({ label: label, amt: amt });
      count(amt);
    }
    /* Branding setup: once per logo + position + method, nested under the first cap line carrying it */
    order.forEach(function (k) {
      var g = groups[k];
      g.parts = setupFees(g.m, g.qty, g.first, g.idx);
      g.amt = g.parts.reduce(function (s, f) { return s + f.amt; }, 0);
      g.parts.forEach(function (f) {
        f.text = g.m.n + ' setup';
        var label = g.pos + ' – ' + f.text + ' – ' + g.logoName + ' (' + g.qty + (g.qty === 1 ? ' cap' : ' caps') + ')';
        fees.push({ label: label, amt: f.amt, group: k });
        var id = SETUP_VARIANTS[f.amt.toFixed(2)];
        if (id) children.push({ parent: g.owner, id: id, quantity: 1, properties: { For: label } });
      });
    });
    /* Sample cap: its own branding is nested under the sample line, so the sample and its branding sit together */
    var sampleLineKey = {};
    haveSamples.forEach(function (it) { if (!sampleLineKey[it.variant_id]) sampleLineKey[it.variant_id] = it.key; });
    sampleOrder.forEach(function (id) {
      var sm = samples[id];
      fees.push({ label: 'Sample cap for your approval' + (sm.brand ? ' (incl. branding)' : '') + ' – ' + sm.title, amt: sm.amt, sample: id });
      var sk = sampleLineKey[id];
      if (!sk) return;
      (sm.parts || []).forEach(function (x) {
        var bid = BRAND_VARIANTS[x.amt.toFixed(2)];
        if (bid) children.push({ parent: sk, id: bid, quantity: 1, properties: { For: 'Branding on this sample – ' + x.pos + ' – ' + x.n } });
      });
    });
    var problems = [], fixes = [];
    Object.keys(od).forEach(function (st) {
      var g = od[st];
      addFee('Sample – ' + st, OD_SAMPLE);
      if (g.design) addFee('Design fee – ' + st, OD_DESIGN);
      if (g.qty < OD_TIERS[0]) problems.push(st + ' needs at least ' + OD_TIERS[0] + ' units (you have ' + g.qty + ').');
      var t = odTier(g.qty);
      g.lines.forEach(function (it) {
        var tv = ((it.properties || {})._bmc_tv || '').split(',');
        var want = Number(tv[t]);
        if (want && want !== it.variant_id) fixes.push({ key: it.key, id: want, quantity: it.quantity, properties: it.properties });
      });
    });
    /* Quantity tiers: every line of a colour moves to the price band for the total of that colour */
    Object.keys(tiers).forEach(function (tk) {
      var g = tiers[tk];
      var ids = tk.split(',').map(Number), tq = String(g.tq).split(',').map(Number);
      var t = 0;
      tq.forEach(function (q, i) { if (g.qty >= q) t = i; });
      if (g.min && g.qty < g.min) problems.push(g.title + ' needs at least ' + g.min + ' (you have ' + g.qty + ').');
      g.lines.forEach(function (it) {
        var want = ids[Math.min(t, ids.length - 1)];
        if (want && want !== it.variant_id) fixes.push({ key: it.key, id: want, quantity: it.quantity, properties: it.properties });
      });
    });
    Object.keys(methodQty).forEach(function (k) {
      var m = method(k);
      if (m && m.min && methodQty[k] < m.min) {
        problems.push(m.n + ' needs at least ' + m.min.toLocaleString('en-ZA') + ' caps in total (you have ' + methodQty[k] + '). You can mix cap styles and colours to reach it.');
      }
    });
    var feeTotal = fees.reduce(function (s, f) { return s + f.amt; }, 0);
    var haveChildren = {};
    cart.items.forEach(function (it) {
      if (!it.parent_relationship) return;
      var pk = it.parent_relationship.parent_key;
      (haveChildren[pk] = haveChildren[pk] || []).push(it);
    });
    /* Delivery estimate: matches the checkout shipping rate, which counts every cap shipped (sample caps included) */
    var ship = shipping(caps + haveSamples.reduce(function (n, it) { return n + it.quantity; }, 0));
    return { caps: caps, capsTotal: capsTotal / 100, brandEst: brandEst, lineEst: lineEst, priceOf: priceOf, unpriced: Object.keys(unpriced), groups: groups, lineGroups: lineGroups, lineBrandings: lineBrandings, fees: fees, feeTotal: feeTotal, need: need, have: feeLines, children: children, haveChildren: haveChildren, items: cart.items, samples: samples, haveSamples: haveSamples, problems: problems, fixes: fixes, unbranded: unbranded, requested: requested, quoteMethods: Object.keys(quoteMethods), ship: ship };
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }

  /* Keep the cart in step with the order:
     - on-demand and quantity-tier lines on the right price band
     - one sample cap per branded cap style/colour
     - Branding and Branding setup nested under the cap line they belong to, sample branding nested under the sample
     - the main cap lines listed above their sample (new lines are added at the top, so the owner is re-added if needed)
     - old un-nested charge lines removed */
  function syncFees(cart, a) {
    var p = Promise.resolve(), changed = false;
    function q(fn) { p = p.then(fn); changed = true; }
    a.fixes.forEach(function (f) {
      q(function () { return post('/cart/change.js', { id: f.key, quantity: 0 }); });
      q(function () { return post('/cart/add.js', { items: [{ id: f.id, quantity: f.quantity, properties: f.properties }] }); });
    });
    if (a.fixes.length) return p.then(function () { return true; });

    /* Sample caps: exactly one per branded cap style/colour */
    var kept = {}, sampleAdds = [];
    (a.haveSamples || []).forEach(function (it) {
      var want = a.samples && a.samples[it.variant_id];
      if (want && !kept[it.variant_id]) {
        kept[it.variant_id] = 1;
        if (it.quantity !== 1) q(function () { return post('/cart/change.js', { id: it.key, quantity: 1 }); });
        return;
      }
      q(function () { return post('/cart/change.js', { id: it.key, quantity: 0 }); });
    });
    var noSample = {};
    try { noSample = JSON.parse(sessionStorage.getItem('bmcNoSample') || '{}'); } catch (e) {}
    Object.keys(a.samples || {}).forEach(function (id) {
      if (kept[id] || noSample[id]) return;
      sampleAdds.push({ id: Number(id), quantity: 1, properties: { _bmc_sample: '1', Sample: 'Pre-production sample for your approval' } });
    });
    sampleAdds.forEach(function (x) {
      q(function () {
        return post('/cart/add.js', { items: [x] }).then(function (r) {
          if (r && r.ok) return;
          noSample[x.id] = 1;   /* sold out: the sample is then confirmed on the quote */
          try { sessionStorage.setItem('bmcNoSample', JSON.stringify(noSample)); } catch (e) {}
        });
      });
    });
    if (sampleAdds.length || changed) return p.then(function () { return true; });

    /* Top-level charge lines: only custom-cap sample/design fees belong there; everything else is old and goes */
    var sets = {}, adds = [];
    a.items.forEach(function (it) {
      if (!isFee(it) || it.parent_relationship) return;
      var odAmt = Object.keys(OD_VARIANTS).filter(function (k) { return OD_VARIANTS[k] === it.variant_id; })[0];
      if (!odAmt) sets[it.key] = 0;
    });
    Object.keys(OD_VARIANTS).forEach(function (k) {
      var id = OD_VARIANTS[k], want = a.need[id] || 0, have = a.have[id] || 0;
      if (want === have) return;
      if (have === 0) adds.push({ id: id, quantity: want });
      else a.items.forEach(function (it) { if (it.variant_id === id && !it.parent_relationship) sets[it.key] = want; });
    });
    Object.keys(sets).forEach(function (key) { q(function () { return post('/cart/change.js', { id: key, quantity: sets[key] }); }); });
    if (adds.length) q(function () { return post('/cart/add.js', { items: adds }); });

    /* Wanted nested lines per parent */
    var want = {};
    a.children.forEach(function (c) { (want[c.parent] = want[c.parent] || []).push(c); });
    function sig(list) {
      return list.map(function (c) { return c.id + '|' + c.quantity + '|' + ((c.properties || {}).For || ''); }).sort().join('~');
    }
    var index = {};
    a.items.forEach(function (it, i) { index[it.key] = i; });

    /* Order: a cap line must sit above its sample. If not, re-add it (with its nested lines) so it moves to the top. */
    var readded = {};
    Object.keys(a.samples || {}).forEach(function (vid) {
      var sm = a.samples[vid];
      var sampleLine = (a.haveSamples || []).filter(function (it) { return String(it.variant_id) === String(vid); })[0];
      var owner = a.items.filter(function (it) { return it.key === sm.owner; })[0];
      if (!sampleLine || !owner || index[owner.key] < index[sampleLine.key]) return;
      readded[owner.key] = 1;
      var kids = (want[owner.key] || []).map(function (c) { return { id: c.id, quantity: c.quantity, properties: c.properties, parent_id: owner.variant_id }; });
      q(function () { return post('/cart/change.js', { id: owner.key, quantity: 0 }); });
      q(function () { return post('/cart/add.js', { items: [{ id: owner.variant_id, quantity: owner.quantity, properties: owner.properties }].concat(kids) }); });
    });

    /* Nested lines: rebuild a parent's nested lines when they differ from what the order needs */
    var parents = {};
    Object.keys(want).forEach(function (k) { parents[k] = 1; });
    Object.keys(a.haveChildren).forEach(function (k) { parents[k] = 1; });
    Object.keys(parents).forEach(function (pk) {
      if (readded[pk] || index[pk] == null) return;
      var have = a.haveChildren[pk] || [];
      var w = want[pk] || [];
      var haveSig = sig(have.map(function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties }; }));
      if (haveSig === sig(w)) return;
      have.forEach(function (it) { q(function () { return post('/cart/change.js', { id: it.key, quantity: 0 }); }); });
      if (w.length) q(function () {
        return post('/cart/add.js', { items: w.map(function (c) { return { id: c.id, quantity: c.quantity, properties: c.properties, parent_line_key: pk }; }) });
      });
    });
    return p.then(function () { return changed; });
  }

  /* Product forms: don't send empty optional fields (e.g. Notes) as blank line properties */
  function skipEmpty(e) {
    var form = e.target.closest ? (e.type === 'submit' ? e.target : e.target.closest('form')) : null;
    if (!form || (e.type === 'click' && !e.target.closest('[type="submit"][name="add"]'))) return;
    form.querySelectorAll('textarea[name^="properties["], input[type="text"][name^="properties["]').forEach(function (el) {
      if (el.disabled || el.value.trim()) return;
      el.disabled = true;
      setTimeout(function () { el.disabled = false; }, 1500);
    });
  }
  document.addEventListener('click', skipEmpty, true);
  document.addEventListener('submit', skipEmpty, true);

  window.BMC = { FEE_HANDLE: FEE_HANDLE, FEE_HANDLES: FEE_HANDLES, isFee: isFee, METHODS: METHODS, POSITIONS: POSITIONS, COUNTRIES: COUNTRIES, method: method, money: money, setupFees: setupFees, brandPrice: brandPrice, sampled: sampled, ranks: ranks, shipping: shipping, analyse: analyse, syncFees: syncFees, OD_SAMPLE: OD_SAMPLE, OD_DESIGN: OD_DESIGN, OD_DESIGN_TEXT: OD_DESIGN_TEXT, OD_TIERS: OD_TIERS, OD_TIER_LABELS: OD_TIER_LABELS, odTier: odTier };
})();
